import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { SUBMISSION_KEYS } from './queryKeys';

export function useSubmission(formId: string, submissionId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: SUBMISSION_KEYS.detail(orgId ?? '', formId, submissionId),
    queryFn: ({ signal }) => formsService.getSubmission(formId, submissionId, signal),
    staleTime: 60_000,
    enabled: !!orgId && !!formId && !!submissionId,
  });

  return {
    submission: data?.data,
    isLoading,
    isError,
  };
}
